import React from 'react'
import project from '../../project'
import Data from './Data'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
import "../assets/styles/home.scss"

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.scrollDiv = React.createRef()
    this.state = {
      firstInteraction: false,
      appInViewport: false,
      data: undefined,
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      activeCard: null,
      isMobApp: false
    }

    this.loadData = this.loadData.bind(this);
    this.visChange = this.visChange.bind(this);

    const thisState = this
    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('click', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.loadData()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  /*siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break
      
      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        rsiteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break

      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break
      
      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }
  */

  loadData () {
    this.setState({
      data: Data
    }, function () {
      if ( this.state.breach === true ) {
        // this.dataSlash()
      }
    });
  }

  expandCard (e, id) {
    
    if ( ( this.state.breach === true ) && ( id > 2 ) )  {
      this.closeCard()
      return
    }
    
    const targetRow = e.target.closest('.nnd-row')
    const targetSection = targetRow.querySelector('.nnd-col-text-content')
    const targetSectionHeight = targetSection.offsetHeight
    const targetImage = targetRow.querySelector('.nnd-cta')
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-row.nnd-active")

    //console.log('targetRow', targetRow)
    //console.log('targetSection', targetSection)
    //console.log('targetSectionHeight', targetSectionHeight)
    //console.log('targetImage', targetImage)
    //console.log('targetImageHeight', targetImageHeight)
    //console.log('existActiveRow', existActiveRow)
    //console.log('-----')

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      
      this.setState({
        activeCard: null
      }, function () {
        // targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      
      if (existActiveRow) {
        // const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-col-img').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        // existActiveRow.style.height = existActiveRowImageHeight + 'px'
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        // currentCard.style.height = targetImageHeight + 'px'
        // targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  closeCard () {
    const existActiveRow = document.querySelector(".nnd-row.nnd-active")
    if (existActiveRow) {
      
      this.setState({
        activeCard: null
      }, function () {
        // const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-col-img').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        // existActiveRow.style.height = existActiveRowImageHeight + 'px'
        // this.scroll2message()
      });

    } else {
      // this.scroll2message()
    }
    
  }

  render() {
    const cards = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={item.id} className={`nnd-row nnd-event-${item.id} nnd-location-${item.location}`} >
           
            <div className="nnd-cta" onClick={(e) => { this.expandCard(e, item.id); e.preventDefault() }}>
              <h4 className="nnd-cta-name">{ item.id }</h4>
              <div className="nnd-cta-popout">{ item.heading }</div>
            </div>
           
           <section className="nnd-col-text">
             <div className="nnd-col-text-content">
                <h4><span className="nnd-title">{ item.heading }</span></h4>
                <img className="nnd-photo" src={require(`../assets/images/${item.image}`)} />
                <div className="nnd-col-text-inner">
                  <p className="nopad">{ item.sports }</p>
                  {/*<p className=" borderTop">{ item.copy }</p>*/}
                </div>
                <div className="nnd-cta-icon" data-index={item.id} onClick={(e) => { this.expandCard(e, item.id); e.preventDefault() }}>
                  <div className="nnd-cta-icon_plus"></div>
                  <div className="nnd-cta-icon_plus_vertical"></div>
                </div>
             </div>
             
           </section>

         </div>
        )
      }
    }) : ''

    const isActiveCard = this.state.activeCard

    return (
      <div className={'nnd-container'}>
        <div className="nnd-header">
          <h3>Paris 2024 - Venues</h3>
        </div>
        <div className={isActiveCard !== null ? 'nnd-cont-main nnd-activeCard' : 'nnd-cont-main'}>
          <div className="nnd-map"></div>
          {cards}
          <span className="nnd-ref nnd-ref1">Seine</span>
          <span className="nnd-ref nnd-ref2">Eiffel Tower</span>
          <span className="nnd-ref nnd-ref3">Arc de Triomphe</span>
          <span className="nnd-ref nnd-ref4">Sacré-Cœur</span>
          <span className="nnd-ref nnd-ref5">Luxor Obelisk</span>
          <span className="nnd-ref nnd-ref6">Louvre</span>
          <span className="nnd-ref nnd-ref7">Notre-Dame</span>
          
        </div>
        <div className="nnd-key">
          <span className="nnd-key-item nnd-key-p"><span className="nnd-disc"></span>Paris</span>
          <span className="nnd-key-item nnd-key-f"><span className="nnd-disc"></span>France</span>
          <span className="nnd-key-item nnd-key-o"><span className="nnd-disc"></span>Overseas</span>
        </div>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js